import axiosClient, { AxiosResponse } from 'axios';

// Delete
export const deleteChatConfiguration = async (
  apiUrl: string,
  configurationId: string,
  sessionId: string,
  orgId: string
): Promise<AxiosResponse | Error> => {
  return axiosClient.delete(`${apiUrl}/configurations/${configurationId}?orgId=${orgId}`, {
    headers: { 'session-id': sessionId },
  });
};
